var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mutation, State } from 'vuex-simple';
var DialogModule = /** @class */ (function () {
    function DialogModule(root) {
        this.root = root;
        this.itemCanBeDeleted = true;
        this.itemCanBeDeletedMessage = '';
        this.itemHasWarning = true;
        this.itemHasWarningMessage = '';
        this.itemCanBeRestored = true;
        this.deleteDialogVisible = false;
        this.restoreDialogVisible = false;
        this.mode = '';
        this.dialogVisible = false;
    }
    DialogModule.prototype.setItemCanBeDeleted = function (payload) {
        this.itemCanBeDeleted = payload.value;
        this.itemCanBeDeletedMessage = payload.message;
    };
    DialogModule.prototype.setItemHasWarning = function (payload) {
        this.itemHasWarning = payload.value;
        this.itemHasWarningMessage = payload.message;
    };
    DialogModule.prototype.setItemCanBeRestored = function (value) {
        this.itemCanBeRestored = value;
    };
    DialogModule.prototype.openDeleteDialog = function (item) {
        this.root.items.selectedItem = item;
        this.deleteDialogVisible = true;
    };
    DialogModule.prototype.closeDeleteDialog = function () {
        this.deleteDialogVisible = false;
        this.root.items.selectedItem = {};
    };
    DialogModule.prototype.openRestoreDialog = function (item) {
        this.root.items.selectedItem = item;
        this.restoreDialogVisible = true;
    };
    DialogModule.prototype.closeRestoreDialog = function () {
        this.root.items.selectedItem = {};
        this.restoreDialogVisible = false;
    };
    DialogModule.prototype.openDialog = function (payload) {
        this.root.items.selectedItem = payload.item;
        this.mode = payload.mode;
        this.dialogVisible = true;
    };
    DialogModule.prototype.closeDialog = function () {
        this.root.items.selectedItem = {};
        this.mode = '';
        this.dialogVisible = false;
    };
    var _a, _b;
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "itemCanBeDeleted", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], DialogModule.prototype, "itemCanBeDeletedMessage", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "itemHasWarning", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], DialogModule.prototype, "itemHasWarningMessage", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "itemCanBeRestored", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "deleteDialogVisible", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "restoreDialogVisible", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], DialogModule.prototype, "mode", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], DialogModule.prototype, "dialogVisible", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "setItemCanBeDeleted", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "setItemHasWarning", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "setItemCanBeRestored", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof T !== "undefined" && T) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "openDeleteDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "closeDeleteDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof T !== "undefined" && T) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "openRestoreDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "closeRestoreDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "openDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DialogModule.prototype, "closeDialog", null);
    return DialogModule;
}());
export { DialogModule };
